import { Suspense, lazy, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { CartProvider } from '@/contexts/CartContext'
import { CustomerIdentityProvider } from '@/contexts/CustomerIdentityContext'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import Loading from '@/components/shared/Loading'
import { loadAnalyticsDeferred } from '@/lib/firebase'

// Route-level code-splitting: visitors landing on /r/:slug (the common case)
// don't ship WelcomePage's JS, and vice versa.
const WelcomePage = lazy(() => import('@/components/restaurant/WelcomePage'))
const RestaurantMenuPage = lazy(() => import('@/pages/RestaurantMenuPage'))

const NotFound = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Página Não Encontrada</h2>
      <p className="text-muted-foreground mb-6">A página que você está procurando não existe.</p>
      <button
        onClick={() => window.location.href = '/'}
        className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
      >
        Ir para o Início
      </button>
    </div>
  </div>
)

function App() {
  // Kick off Firebase Analytics after the page is interactive — it has no
  // dependency on the render path and shouldn't compete with menu fetches.
  useEffect(() => {
    const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 2000))
    const id = schedule(() => { loadAnalyticsDeferred() })
    return () => {
      if (window.cancelIdleCallback && typeof id === 'number') window.cancelIdleCallback(id)
      else clearTimeout(id)
    }
  }, [])

  return (
    <ErrorBoundary>
      <CustomerIdentityProvider>
        <CartProvider>
          <Suspense fallback={<Loading className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/restaurants/:restaurantId" element={<RestaurantMenuPage />} />
              <Route path="/r/:restaurantId" element={<RestaurantMenuPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Toaster />
        </CartProvider>
      </CustomerIdentityProvider>
    </ErrorBoundary>
  )
}

export default App
